import React, { useState, useEffect } from "react";
import * as CollapseStyles from "../../../../../common-deprecated/styles/v2/lexus/custom/Collapse";
import * as CompareSpecsStyles from "../styles/CompareSpecs";
import * as Table from "../../../../../common-deprecated/components/styles/Table";
import { ToggleIconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import EquipmentOrSpecPrice from "./EquipmentOrSpecPrice";
import EquipmentOrSpecValue from "./EquipmentOrSpecValue";
import ItemDescription from "./ItemDescription";
import { type CompareV2LabelType, CompareV2Label } from "../../../utils/labels";
import CompareTable from "../../common/CompareTable";
import type { EquipmentSpecNameIdType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import {
    collapsibleListHasItemsToShow,
    showItemsForThisRow,
} from "../../../../../shared-logic/features/compare/utils/collapsibleListUtils";

type CollapsibleListPropsType = {
    header: string;
    items: EquipmentSpecNameIdType[];
    onlyShowDifferences: boolean;
    showAllSpecs: boolean;
    cultureName: string;
    isMessageLabel: boolean;
    showPrices: boolean;
    carColours?: string[];
    isPdf?: boolean;
    expandTrackEvent?: () => void;
};

const CollapsibleList = (props: CollapsibleListPropsType): JSX.Element | null => {
    const { header, items, onlyShowDifferences, showAllSpecs, isMessageLabel, cultureName } = props;
    const { showPrices, carColours, isPdf, expandTrackEvent } = props;

    const [isOpen, setIsOpen] = useState<boolean>(showAllSpecs);

    // When the showAllSpecs from the parent changes this overrides all local isOpen states
    useEffect(() => {
        setIsOpen(showAllSpecs);
    }, [showAllSpecs]);

    return collapsibleListHasItemsToShow(onlyShowDifferences, items) ? (
        <CollapseStyles.Wrapper>
            <CollapseStyles.Header
                isPdf={isPdf}
                onClick={() => {
                    setIsOpen(!isOpen);
                    if (!isOpen && expandTrackEvent) expandTrackEvent();
                }}
            >
                <span>{isMessageLabel ? <CompareV2Label label={header as CompareV2LabelType} /> : header}</span>
                {!isPdf && (
                    <ToggleIconWrapper iconColor="black" isDown={isOpen}>
                        <Icon variant="chevronDown" />
                    </ToggleIconWrapper>
                )}
            </CollapseStyles.Header>
            {isOpen && (
                <CollapseStyles.Body noBorder noSpacing>
                    {items.map(
                        (item: EquipmentSpecNameIdType) =>
                            showItemsForThisRow(onlyShowDifferences, !!item.allValuesAreTheSame) && (
                                <CollapseStyles.Item key={item.id} p="0" border="none">
                                    {item.values && item.values.length && (
                                        <CompareTable
                                            items={item.values}
                                            columnChild={(value, index) => (
                                                // wrapper div here for pdf that can't handle the flexbox wrapper*/}
                                                <Table.InnerCol>
                                                    <CompareSpecsStyles.Label>{item.name}</CompareSpecsStyles.Label>
                                                    <CompareSpecsStyles.Value>
                                                        <EquipmentOrSpecValue
                                                            value={value}
                                                            carColour={carColours && carColours[index]}
                                                        />
                                                        <EquipmentOrSpecPrice
                                                            cultureName={cultureName}
                                                            price={value.price}
                                                            showPrices={showPrices}
                                                        />
                                                    </CompareSpecsStyles.Value>
                                                </Table.InnerCol>
                                            )}
                                        />
                                    )}

                                    <ItemDescription isPdf={isPdf} heightLimit={40} description={item.description} />
                                </CollapseStyles.Item>
                            ),
                    )}
                </CollapseStyles.Body>
            )}
        </CollapseStyles.Wrapper>
    ) : null;
};

export default CollapsibleList;
